import { isStagingEnvironment } from '@/utils/environment-utils'

export const ANGEL_GUILD_PREMIUM_YEARLY_OFFER_ID = isStagingEnvironment() ? '1853' : '1841'
export const ANGEL_GUILD_PREMIUM_MONTHLY_OFFER_ID = isStagingEnvironment() ? '1821' : '1848'
export const ANGEL_GUILD_BASIC_MONTHLY_OFFER_ID = isStagingEnvironment() ? '4377' : '1873'
export const ANGEL_GUILD_BASIC_MONTHLY_ADD_A_LINE_OFFER_ID = isStagingEnvironment() ? '3104' : '29636'
export const ANGEL_GUILD_BASIC_YEARLY_OFFER_ID = isStagingEnvironment() ? '4378' : '3169'
export const ANGEL_GUILD_BASIC_NO_ADS_MONTHLY_OFFER_ID = isStagingEnvironment() ? '4379' : '14359'
export const ANGEL_GUILD_BASIC_NO_ADS_MONTHLY_ADD_A_LINE_OFFER_ID = isStagingEnvironment() ? '3103' : '29635'
export const ANGEL_GUILD_BASIC_NO_ADS_YEARLY_OFFER_ID = isStagingEnvironment() ? '4380' : '14361'

// Experiment variant offer IDs (staging falls back to base tier offer IDs)
export const ANGEL_GUILD_PREMIUM_MONTHLY_22_OFFER_ID = isStagingEnvironment() ? '1821' : '14356'
export const ANGEL_GUILD_PREMIUM_MONTHLY_25_OFFER_ID = isStagingEnvironment() ? '1821' : '14357'
export const ANGEL_GUILD_PREMIUM_YEARLY_189_OFFER_ID = isStagingEnvironment() ? '1853' : '14362'
export const ANGEL_GUILD_PREMIUM_YEARLY_199_OFFER_ID = isStagingEnvironment() ? '1853' : '14363'
export const ANGEL_GUILD_BASIC_NO_ADS_MONTHLY_20_OFFER_ID = isStagingEnvironment() ? '4379' : '14358'
export const ANGEL_GUILD_BASIC_NO_ADS_YEARLY_179_OFFER_ID = isStagingEnvironment() ? '4380' : '14360'
